<template>
  <v-card
    border
    tile
  >
    <v-card-title class="fs-20 fw-600">
      {{ $bct(`About this ${terms.program.toLowerCase()}`) }}
    </v-card-title>

    <v-card-text>
      <div class="c-black fs-16 fw-400 ws-pre-line">
        {{ $bct(provider.description || 'No description available') }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import useTerms from '@/shared/composables/useTerms';

defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const { terms } = useTerms();
const $bct = inject('translator');
</script>
